import React from 'react';

import {DISCOUNT_MODES, DISCOUNT_TYPES} from "./discounstInterface";
import {getQuotePriceWithDiscounts, getTotalPrice, toFixedPrice} from "../../misc/helpers";
import {getSubTotalPrice} from "./discountFunctions";

export default class DiscountCommon extends React.Component {

  handleDiscountSelectClick = () => {
    if (this.isDiscountDisabled()) {
      return false
    }
    const currentDiscount = this.props.discount;
    currentDiscount.selected = !currentDiscount.selected;
    this.updateDiscount(currentDiscount);
  };

  setDiscountProperty = (property, value) => {
    const currentDiscount = this.props.discount;
    currentDiscount[property] = value;
    this.updateDiscount(currentDiscount);
  };

  updateDiscount = (currentDiscount) => {
    this.props.setDiscountSections(this.props.discountSections.map((discountSection) => {
      if (discountSection.order === this.props.discountSection.order) {
        discountSection.discounts.map(discount => {
          if (currentDiscount.order === discount.order) {
            return currentDiscount
          }
          return discount
        });
        if (currentDiscount.selected && currentDiscount.mode === DISCOUNT_MODES.or && !currentDiscount.isSubTotal) {
          discountSection.discounts = discountSection.discounts.map(discount => {
            if ((currentDiscount.order !== discount.order) && (discount.mode === DISCOUNT_MODES.or) && !discount.isSubTotal) {
              discount.selected = false
            }
            return discount
          });
        }
      }
      return discountSection
    }));
  };

  getGrandTotal = (withoutDiscount = null) => {
    const totalPrice = getTotalPrice(null, false);
    return getQuotePriceWithDiscounts(totalPrice, withoutDiscount ? [withoutDiscount] : []);
  }

  isDiscountDisabled = () => {
    const {discount, discountSection} = this.props;
    if (discount.selected) {
      return false
    }
    const grandTotal = this.getGrandTotal();
    const discountAmount = discount.type === DISCOUNT_TYPES.price ? discount.amount : grandTotal * discount.amount / 100;
    let disabled = (grandTotal - discountAmount) < 0;
    if (disabled && discount.mode === DISCOUNT_MODES.or) {
      if (discountSection.discounts.some(currentDiscount => {
        return (currentDiscount.order !== discount.order) // take othere discounts from this section
          && (currentDiscount.mode === DISCOUNT_MODES.or) // with OR mode
          && currentDiscount.selected && !(discount.isRidged && !discount.specialVisible) // already selected
          && (this.getGrandTotal(currentDiscount) - discountAmount) > 0
        // price without this discount minus current discount amount still more than 0
      })) {
        disabled = false
      }
    }
    return disabled
  }

  getDiscountPercentageAmount = () => {
    const grandTotal = getSubTotalPrice(this.props.discountSections, this.props.discountSection, this.props.discount, true);
    const priceTaken = grandTotal * this.props.discount.amount / 100 // for ex. 25% from 2700 = 625
    return toFixedPrice(Math.trunc(priceTaken * 100) / 100);
  };

}
